import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import freemeal from "../assets/freemeal.png";
import "./FreeMealBanner.css";

/**
 * FreeMealBanner
 *
 * Shown only to non-logged-in visitors.
 * Displays the freemeal.png image with an overlay showing:
 *   - "X slots left" (live from the API)
 *   - "Login to claim →" button
 */
const FreeMealBanner = ({ onLoginClick }) => {
  const navigate = useNavigate();
  const [slotsLeft, setSlotsLeft] = useState(null);
  const [offerData, setOfferData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchSlots = async () => {
      try {
        const res = await axios.get(
          "https://dailydish.in/api/offer/acquisition/public-slots",
        );
        if (!cancelled && res.data) {
          setSlotsLeft(res.data.slotsLeft ?? 0);
          setOfferData(res.data);
        }
      } catch {
        // Non-critical — banner still renders without slot count
      }
    };
    fetchSlots();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="fmb-wrapper">
      <div className="fmb-image-container">
        <img
          src={freemeal}
          alt="5 free meals for new residents"
          className="fmb-image"
        />

        {/* Overlay row: slots left + login button */}
        {/* <div className="fmb-overlay">
          {slotsLeft !== null && slotsLeft > 0 && (
            <span className="fmb-slots-pill">
              <span className="fmb-slots-count">{slotsLeft}</span>
              <span className="fmb-slots-label">slots left</span>
            </span>
          )}
         
        </div> */}
      </div>
    </div>
  );
};

export default FreeMealBanner;
